const isProd = import.meta.env.PROD;
const base = import.meta.env.VITE_BASE_PATH || "/";
export const apiBaseURL = isProd ? `${base}api/` : import.meta.env.VITE_API;
export const apiAuthHeader = isProd
  ? {}
  : { Authorization: `Bearer ${import.meta.env.VITE_BEARER_TOKEN}` };
